import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import { useCustomerDetailsStyles } from './CustomerDetails';
import NoteEdit from './NoteEdit';

const NoteRow = ({ customer }) => {
  const { admin_note } = customer;
  const classes = useCustomerDetailsStyles();
  const [openNoteEdit, setOpenNoteEdit] = useState(false);

  return (
    <>
      <Grid container spacing={1} alignItems="center" wrap="nowrap">
        <Grid item xs>
          <Typography
            className={classes.fw500}
            // allows us to render newlines
            style={{ whiteSpace: 'pre-line' }}
          >
            {admin_note}
          </Typography>
        </Grid>
        <Grid item>
          <IconButton size="small" onClick={() => setOpenNoteEdit(true)}>
            <EditIcon />
          </IconButton>
        </Grid>
      </Grid>
      <Typography
        variant="body2"
        className={classes.gray}
        style={{ textAlign: 'center', paddingTop: '50px' }}
      >
        Notes are not visible to the customer
      </Typography>
      {openNoteEdit && (
        <NoteEdit
          openEdit={openNoteEdit}
          setOpenEdit={setOpenNoteEdit}
          customer={customer}
        />
      )}
    </>
  );
};

export default NoteRow;
